import { jsxs as p, jsx as a } from "react/jsx-runtime";
import { c as i } from "../../../clsx-OuTLNxxd.js";
import { useEffect as x } from "react";
import { IMAGE_URL as T } from "../../../config/destination.js";
import { B as k } from "../../../button.types-khNMDxMV.js";
import { I as d } from "../../../icon-BnqXyiyH.js";
import "../icon/iconsList.js";
import { useImageBanner as E } from "./imageBanner.hooks.js";
const z = "_blur_17awh_45", A = "_pointer_17awh_59", B = "_arrow_17awh_65", M = "_prev_17awh_78", $ = "_next_17awh_82", j = "_active_17awh_109", R = "_large_17awh_158", e = {
  "grid-container": "_grid-container_17awh_29",
  "grid-btn": "_grid-btn_17awh_34",
  "grid-wrapper": "_grid-wrapper_17awh_37",
  "grid-item": "_grid-item_17awh_40",
  blur: z,
  pointer: A,
  "empty-item": "_empty-item_17awh_62",
  arrow: B,
  prev: M,
  next: $,
  "pagination-slider": "_pagination-slider_17awh_86",
  active: j,
  large: R
};
function K({
  images: l = [],
  blur: m,
  className: h,
  buttonLabel: u,
  onClickButton: _,
  onChange: c,
  onSlideChange: n,
  ...w
}) {
  const { sliderRef: v, handleTouchStart: f, handleTouchMove: g, handleTouchEnd: b, currentIndex: o, setCurrentIndex: s } = E(l.length), y = (r) => {
    s(r), c == null || c(r);
  };
  x(() => {
    n == null || n(o), o === 5 && m && s(o - 1);
  }, [o, n, s, m]);
  const I = Array.from({ length: 5 - l.length }, (r, t) => t), N = [...l].sort((r, t) => r.order_display - t.order_display);
  return /* @__PURE__ */ p("div", { className: i(e["grid-container"], h), ...w, children: [
    /* @__PURE__ */ p(
      "div",
      {
        className: e["grid-wrapper"],
        ref: v,
        onTouchStart: f,
        onTouchMove: g,
        onTouchEnd: b,
        children: [
          N.map((r, t) => /* @__PURE__ */ a(
            "button",
            {
              tabIndex: c ? 0 : void 0,
              className: i(
                t === 0 && e.large,
                e["grid-item"],
                c && e.pointer,
                t !== 0 && m && e.blur
              ),
              onClick: c ? () => {
                y(t), s(t);
              } : void 0,
              "aria-label": `Show carousel image ${t}`,
              children: /* @__PURE__ */ a("img", { src: r.src, alt: r.title ?? "" })
            },
            r.src
          )),
          I.map((r) => /* @__PURE__ */ a("div", { className: e["empty-item"], children: /* @__PURE__ */ a("img", { src: `${T}/placeholders/home_gallery.svg`, alt: "Home placeholder" }) }, r))
        ]
      }
    ),
    _ && /* @__PURE__ */ a(k, { onClick: _, className: e["grid-btn"], color: "ghost", size: "medium", children: u }),
    o !== 0 && /* @__PURE__ */ a(
      "button",
      {
        className: i(e.arrow, e.prev),
        color: "secondary",
        onClick: () => s((r) => r - 1),
        "aria-label": "carousel-prev-button",
        children: /* @__PURE__ */ a(d, { name: "up-arrow", size: "small" })
      }
    ),
    o !== l.length - 1 && /* @__PURE__ */ a(
      "button",
      {
        className: i(e.arrow, e.next),
        color: "secondary",
        onClick: () => s((r) => r + 1),
        "aria-label": "carousel-next-button",
        children: /* @__PURE__ */ a(d, { name: "up-arrow", size: "small" })
      }
    ),
    /* @__PURE__ */ a("div", { className: e["pagination-slider"], children: l.map((r, t) => /* @__PURE__ */ a(
      "span",
      {
        className: i(
          o === t && e.active,
          o - 1 === t && e.prev,
          o + 1 === t && e.next
        ),
        style: {
          left: `${24 - o * 12}px`
        }
      },
      r.src
    )) })
  ] });
}
export {
  K as ImageBanner
};
